import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// material
import {
  Box,
  Radio,
  Stack,
  Button,
  Drawer,
  Divider,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
// components
import Iconify from '../Iconify';
import Scrollbar from '../Scrollbar';

// ----------------------------------------------------------------------

export const FILTER_ROLE_OPTIONS = [
  {
    key: '',
    value: 'All',
  },
  {
    key: 'admin',
    value: 'Admin',
  },
  {
    key: 'manager',
    value: 'Manager',
  },
];
export const FILTER_STATUS_OPTIONS = [
  {
    key: '',
    value: 'All',
  },
  {
    key: 'Active',
    value: 'Active',
  },
  {
    key: 'Inactive',
    value: 'Inactive',
  },
];

// ----------------------------------------------------------------------

PromotionFilter.propTypes = {
  isOpenFilter: PropTypes.bool,
  onOpenFilter: PropTypes.func,
  onCloseFilter: PropTypes.func,
};

function PromotionFilter({ isOpenFilter, setDefaultPage, onCloseFilter, filter, setFilter }) {
  const [status, setStatus] = useState(filter.status);
  const { t } = useTranslation();

  const handleOnSubmit = () => {
    setFilter({
      status,
    });
    setDefaultPage();
    onCloseFilter();
  };

  const handleClearOn = () => {
    setStatus('');
    setFilter({
      status: '',
    });
    setDefaultPage();
    onCloseFilter();
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpenFilter}
        onClose={onCloseFilter}
        PaperProps={{
          sx: { width: 280, border: 'none', overflow: 'hidden' },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 2 }}>
          <Typography variant="subtitle1" sx={{ ml: 1 }}>
            {t('filter.title')}
          </Typography>
          <IconButton onClick={onCloseFilter}>
            <Iconify icon="eva:close-fill" width={20} height={20} />
          </IconButton>
        </Stack>

        <Divider />

        <Scrollbar>
          <Stack spacing={3} sx={{ p: 3 }}>
            <div>
              <Typography variant="subtitle1" gutterBottom>
                {t('filter.status')}
              </Typography>
              <RadioGroup value={status} onChange={(e) => setStatus(e.target.value)}>
                {FILTER_STATUS_OPTIONS.map((item) => (
                  <FormControlLabel key={item.value} value={item.key} control={<Radio />} label={item.value} />
                ))}
              </RadioGroup>
            </div>
          </Stack>
        </Scrollbar>

        <Divider />

        <Box sx={{ pt: 3, px: 3 }}>
          <Button
            fullWidth
            size="large"
            type="button"
            color="inherit"
            variant="outlined"
            onClick={handleClearOn}
            startIcon={<Iconify icon="ic:round-clear-all" />}
          >
            {t('filter.clear')}
          </Button>
        </Box>
        <Box sx={{ px: 3, py: 1 }}>
          <Button
            fullWidth
            size="large"
            type="button"
            color="primary"
            variant="outlined"
            onClick={handleOnSubmit}
            startIcon={<Iconify icon="bx:search-alt" />}
          >
            {t('filter.submit')}
          </Button>
        </Box>
      </Drawer>
    </>
  );
}

export default React.memo(PromotionFilter);
